import * as t from 'io-ts';

export const MotivationPopupSettingsC = t.strict({
  timeInSecondsBeforeOpen: t.number,
  timeInSecondsBeforeClose: t.number,
});

export type MotivationPopupSettings = t.TypeOf<typeof MotivationPopupSettingsC>;
